export const ACTION_OUTGOING_HELPDESK_REQUEST = 'ACTION_OUTGOING_HELPDESK_REQUEST';
export const ACTION_OUTGOING_REFUND_REQUEST = 'ACTION_OUTGOING_REFUND_REQUEST';
